(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["back-in-stock"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bis-form]').forEach(function (form) {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var msg = form.querySelector('[data-bis-msg]');
    var btn = form.querySelector('[type="submit"]');
    var phoneEl = form.querySelector('[name="phone"]');
    var payload = {
      productId: form.querySelector('[name="productId"]').value,
      variantId: form.querySelector('[name="variantId"]').value,
      email: form.querySelector('[name="email"]').value,
    };
    if (phoneEl && phoneEl.value) payload.phone = phoneEl.value;
    if (btn) btn.disabled = true;
    fetch(form.dataset.action, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        if (msg) { msg.hidden = false; msg.className = 'bis__msg is-ok'; msg.textContent = form.dataset.okText || 'Parfait ! Vous serez prévenu(e) dès le retour en stock.'; }
        form.reset();
      })
      .catch(function () {
        if (msg) { msg.hidden = false; msg.className = 'bis__msg is-err'; msg.textContent = form.dataset.errText || 'Une erreur est survenue. Réessayez.'; }
      })
      .finally(function () { if (btn) btn.disabled = false; });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
// Préselectionne le pays enregistré sur les formulaires d'édition d'adresse
// (country_option_tags ne marque aucune option selected → sinon l'édition écrase le pays).
document.querySelectorAll('select[name="address[country]"][data-default]').forEach(function (s) {
  if (s.dataset.default) s.value = s.dataset.default;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
function initReviewForms(scope) {
  (scope || document).querySelectorAll('[data-review-form]').forEach(function (form) {
  if (form.dataset.rvInit) return;
  form.dataset.rvInit = '1';
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var msg = form.querySelector('[data-review-msg]');
    var btn = form.querySelector('[type="submit"]');
    var payload = {
      productId: form.querySelector('[name="productId"]').value,
      rating: parseInt((form.querySelector('[name="rating"]:checked') || {}).value, 10),
      authorName: form.querySelector('[name="authorName"]').value,
      email: form.querySelector('[name="email"]').value,
      title: form.querySelector('[name="title"]').value,
      body: form.querySelector('[name="body"]').value,
    };
    if (btn) btn.disabled = true;
    fetch(form.dataset.action, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        if (msg) { msg.hidden = false; msg.className = 'rv__msg is-ok'; msg.textContent = form.dataset.okText || 'Merci ! Votre avis sera publié après modération.'; }
        form.reset();
      })
      .catch(function () {
        if (msg) { msg.hidden = false; msg.className = 'rv__msg is-err'; msg.textContent = form.dataset.errText || 'Une erreur est survenue. Réessayez.'; }
      })
      .finally(function () { if (btn) btn.disabled = false; });
  });
  });
}
initReviewForms(document);
document.addEventListener('shopify:section:load', function (e) { initReviewForms(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spin-wheel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var design = !!(window.Shopify && window.Shopify.designMode);

  function initSpin(root) {
    if (!root || root.dataset.spinInit) return;   // idempotent : re-run safe on shopify:section:load
    root.dataset.spinInit = '1';
    var key = root.dataset.key;
    var opened = false;
    function open() {
      if (opened) return; opened = true;
      root.hidden = false;
      if (!design) { try { sessionStorage.setItem(key, '1'); } catch (e) {} }
    }
    function close() { root.hidden = true; }

    // Live triggers only on the real storefront. In the theme editor we preview on select instead.
    if (!design) {
      try { if (sessionStorage.getItem(key) === '1') return; } catch (e) {}
      if (root.dataset.trigger === 'exit') {
        document.addEventListener('mouseout', function (e) {
          if (!e.relatedTarget && e.clientY <= 0) open();
        });
        setTimeout(open, (parseInt(root.dataset.delay, 10) || 15) * 1000 * 2);
      } else {
        setTimeout(open, (parseInt(root.dataset.delay, 10) || 8) * 1000);
      }
    }

    root.addEventListener('click', function (e) { if (e.target.closest('[data-spin-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var wheel = root.querySelector('[data-spin-wheel]');
    var labels = [].slice.call(root.querySelectorAll('.spin__label'));
    var segAngle = labels.length ? 360 / labels.length : 360;
    // Place each label at its segment centre, upright, near the rim.
    labels.forEach(function (el, i) {
      var mid = i * segAngle + segAngle / 2;
      el.style.transform = 'rotate(' + mid + 'deg) translate(0, -108px) rotate(' + -mid + 'deg) translate(-50%, -50%)';
    });

    var form = root.querySelector('[data-spin-form]');
    var result = root.querySelector('[data-spin-result]');
    var spun = false;
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (spun || !labels.length) return;
      spun = true;
      var email = form.querySelector('[name="email"]').value;
      if (!design) {
        try {
          var fd = new FormData();
          fd.append('form_type', 'customer'); fd.append('utf8', '✓');
          fd.append('contact[email]', email); fd.append('contact[tags]', 'spin-wheel,newsletter');
          fetch('/contact', { method: 'POST', body: fd }).catch(function () {});
        } catch (e2) {}
      }
      var idx = Math.floor(Math.random() * labels.length);
      var mid = idx * segAngle + segAngle / 2;
      var rot = 360 * 5 + (360 - mid);
      wheel.style.transform = 'rotate(' + rot + 'deg)';
      var go = form.querySelector('[data-spin-go]'); if (go) go.disabled = true;
      setTimeout(function () {
        var code = labels[idx].dataset.code || '';
        root.querySelector('[data-spin-code]').textContent = code;
        result.hidden = false;
        form.style.display = 'none';
      }, 4300);
    });

    var copyBtn = root.querySelector('[data-spin-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var code = root.querySelector('[data-spin-code]').textContent;
      if (navigator.clipboard) navigator.clipboard.writeText(code);
    });
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-spin]').forEach(initSpin); }
  boot(document);

  // Theme editor : re-init a re-rendered section, and PREVIEW the modal when its section is
  // selected (otherwise the merchant clicks the section and sees nothing — it's a hidden modal).
  if (design) {
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:section:select', function (e) { var r = e.target.querySelector('[data-spin]'); if (r) r.hidden = false; });
    document.addEventListener('shopify:section:deselect', function (e) { var r = e.target.querySelector('[data-spin]'); if (r) r.hidden = true; });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
